export const formatOrderListQuantity = (quantity: number): string => {
  return quantity.toFixed(2).replace(/\.00$/, "").replace(/(\.\d)0$/, "$1");
};